// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"190":"e2a13a1a","726":"2efc1f8a","775":"fe7b5a1d"}[chunkId] + ".chunk.js";
};